import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import Ajax from '@/lib/ajax_wrapper'
import {request} from '@/lib/ajax_promise'

import * as types from '@/store/mutation_types'

Vue.config.productionTip = false

Ajax.init({
  urlBase: process.env.VUE_APP_API_URL,

  request: request,

  getAuthToken() {
    return store.getters.sessionToken
  },

  onRateLimitExceeded() {
    alert('Rate limit exceeded.')
  },

  onStart() {
    store.commit(types.LOADING, true)
  },

  onFinish() {
    store.commit(types.LOADING, false)
  },

  onUnauthorised() {
    if (!store.state.session.token) {
      router.replace({
        name: 'login',
        query: {returnPath: store.state.previousRoute.fullPath}
      })

      return
    }

    store.dispatch('logoutUser', store.state.session).then(() => {
      router.replace({
        name: 'login'
      })
    })
  }
})

router.beforeEach((to, from, next) => {
  const loggedIn = store.getters.loggedIn
  const companyId = store.getters.currentCompanyId
  const id = store.getters.currentUserId
  const currentUserReadAt = store.state.userReadAt
  const loginRoute = to.name === 'login'

  if (!loginRoute) {
    store.commit(types.PREVIOUS_ROUTE, to)
  }

  store.commit(types.PREVIOUS_ROUTE, from)

  store.commit(types.PREVIOUS_ROUTE, from)

  store.commit(types.PREVIOUS_ROUTE, from)

  store.commit(types.PREVIOUS_ROUTE, from)

  if (loggedIn && !currentUserReadAt) {
    if (companyId) {
      store.dispatch('getCurrentCompanyUser', {companyId, id}).then(() => {
        next()
      })
    } else {
      // assume weve got an admin, and go via the admin controller
      // server will 401 if this is not ok
      store.dispatch('getCurrentUser', {id}).then(() => {
        next()
      })
    }
  } else {
    next()
  }
})

new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app')
